import apiClient from './api';

const paymentService = {
  getPayments: async (params) => {
    return apiClient.get('/payments', { params });
  },

  getPaymentsAdmin: async (params) => {
    return apiClient.get('/payments/admin/payments', { params });
  },

  getPayment: async (id) => {
    return apiClient.get(`/payments/${id}`);
  },

  createPayment: async (data) => {
    return apiClient.post('/payments', data);
  },

  createRazorpayOrder: async (data) => {
    return apiClient.post('/payments/razorpay/order', data);
  },

  verifyRazorpayPayment: async (data) => {
    return apiClient.post('/payments/razorpay/verify', data);
  },

  getReceipt: async (paymentId) => {
    return apiClient.get(`/payments/receipts/${paymentId}`);
  },

  getPaymentSummary: async (params) => {
    return apiClient.get('/payments/reports/summary', { params });
  },

  downloadReport: async (params) => {
    return apiClient.get('/payments/reports/download', {
      params,
      responseType: 'blob',
    });
  },

  getPendingVerifications: async () => {
    return apiClient.get('/payments/admin/payments/pending-verifications');
  },

  verifyPayment: async (paymentId, data) => {
    return apiClient.post(`/payments/admin/payments/${paymentId}/verify`, data);
  },

  rejectPayment: async (paymentId, data) => {
    return apiClient.post(`/payments/admin/payments/${paymentId}/reject`, data);
  },
};

export default paymentService;
